import React from 'react';
import './Footer.css';
import { useTranslation } from '../../hooks/useTranslation';
// Removed extra links/sections; keeping only design data

const Footer = () => {
    const { t } = useTranslation();
    return (
        <footer className="footer" id='contact'>
            <div className="footer-container px-3 md:px-[2%] lg:px-[4%] xl:px-[4%] 2xl:px-[6%] mx-auto ">
                <div className="footer-content flex flex-col md:flex-row md:items-center  justify-between md:gap-8">
                    <div className="footer-section  flex flex-col items-start justify-start">
                        <img src="../logo.svg" className="w-[100px]" alt="Hobby Station" />
                        <p className=" text-[14px]   font-[400] text-[#495057] mt-2">{t("footer.Practical, delightful experiences.")}</p>
                    </div>
                    <div className='flex flex-col items-start justify-start'>
                        <div className='mt-4 flex items-center gap-3'>
                            <img src="../mail.svg" className="w-[18px] h-[18px]" alt="" />
                            <a className='text-[16px]   font-[500]' href='mailto:support@hobbystation.co'>support@hobbystation.co</a>
                        </div>
                        <div className='mt-3 flex items-center gap-3'>
                            <img src="../calling.svg" className="w-[18px] h-[18px]" alt="" />
                            <a className='text-[16px]   font-[500] ltrr' href='tel:+966504336076'>+966 50 433 6076</a>
                        </div>
                        <div className='mt-3 flex items-center gap-3'>
                            <img src="../location.svg" className="w-[18px] h-[18px]" alt="" />
                            <a className='text-[16px]   font-[500] ' target='_blank' rel="noopener noreferrer" href='https://www.google.com/maps/place/%D8%A7%D9%84%D8%B4%D8%B1%D9%82%D9%8A%D8%A9%D8%8C+%D8%A7%D9%84%D8%B7%D8%A7%D8%A6%D9%81+%D8%A7%D9%84%D8%B3%D8%B9%D9%88%D8%AF%D9%8A%D8%A9%E2%80%AD/@21.2744599,40.4223997,16z/data=!3m1!4b1!4m6!3m5!1s0x15e9893146c61ffb:0xcb8d56e5ac8849c0!8m2!3d21.2755609!4d40.41674!16s%2Fg%2F11h1qxmgw?entry=ttu&g_ep=EgoyMDI1MDcyMC4wIKXMDSoASAFQAw%3D%3D'> {t("footer.Eastern, Saudi Arabia")}</a>
                        </div>
                    </div>
                    <div className="footer-section  mt-4 md:mt-0 flex flex-col items-start justify-start">
                        <h4 className=" text-[16px]   font-[500]">{t("footer.follow")}</h4>
                        <div className="social-links gap-3 flex items-center mt-2">
                            <a className="" href="https://www.instagram.com/hobbystation.sa/#" target='_blank' rel="noopener noreferrer" aria-label="Instagram">
                                <img src="../instagram.svg" alt="" />
                            </a>
                            <a className="" href="https://www.tiktok.com/@hobbystation.sa" target='_blank' rel="noopener noreferrer" aria-label="TikTok">
                                <img src="../ticktok.svg" alt="" />
                            </a>
                            <a className=""  href="https://www.snapchat.com/@hobbystation0?invite_id=9k5WL0qs&locale=ar_SA%40calendar%3Dgregorian&share_id=UGw8n8YPQOyfoQxMdJ_pbg&sid=0a1d01ce8f2f494db8c0e202a83ed763" target='_blank' rel="noopener noreferrer" aria-label="Snapchat">
                                <img src="../snap.svg" alt="" />
                            </a>
                            <a className="" href="https://www.linkedin.com/company/hobbystation0/" target='_blank' rel="noopener noreferrer" aria-label="LinkedIn">
                                <img src="../linkedin.svg" alt="" />
                            </a>
                        </div>
                    </div>

                </div>
                <div className=" text-[12px]  font-[400] text-[#555555] flex gap-1 justify-center py-3 border-t-[1px] border-[#E6E6E6]">
                    <p>{t("footer.copyright")}</p><p>{t("footer.copyright2")}</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;